import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";

const ProtectedRoute = ({ allowedTypes, children }) => {
    const authBroker = useSelector((state) => state.auth.authBroker); // adjust according to your store
    console.log("authBroker1", authBroker);
    // if(!_.isEmpty(authBroker)) {
    //   if (allowedTypes.includes(authBroker?.payload?.user?.access_type)) {
    //     return children;
    //   } else {
    //     return <Navigate to="/unauthorized" replace />;
    //   }
    // }else{
      return children;
    // }
};

export default ProtectedRoute;